import { createContext } from 'react';

export interface TooltipContextValue {
  disableTooltips: boolean;
}

const TooltipContext = createContext<TooltipContextValue>({
  disableTooltips: false,
});

export default TooltipContext;
